<template>
  <!-- 提示窗口 -->
  <van-popup
    :value="value"
    @input="$emit('input', $event)"
    class="popup-wrapper"
  >
    <template>
      <div class="content">
        <div class="title">提示</div>
        <div class="desc">
          {{
            isIOSWxMini
              ? "会员专享功能，请升级会员账号后使用"
              : "非常抱歉！只有魔音会员才有此权限，魔音会员在电脑端和手机端权益互通，数据互通！"
          }}
        </div>
        <div class="desc-btn" v-if="isIOSWxMini" @click="onClose">
          <span class="pupBtn">知道了</span>
        </div>
        <template v-else>
          <div class="y-btn" @click="onConfirm">前往购买会员</div>
          <div class="n-btn" @click="onClose">再考虑考虑</div>
        </template>
      </div>
    </template>
  </van-popup>
</template>
<script>
import { judgeDeviceType } from "@/utils/device";
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isIOSWxMini: judgeDeviceType.isIOSWxMini,
    };
  },
  methods: {
    onClose() {
      this.$emit("input", false);
    },
    onConfirm() {
      this.onClose();
      this.$emit("buy-vip");
    },
  },
};
</script>
<style lang="less" scoped>
.popup-wrapper {
  background-color: transparent;
}

.content {
  background: rgba(255, 255, 255, 1);
  border-radius: 20px;
  padding: 60px 40px 50px;
  width: 630px;
  box-sizing: border-box;
  font-size: 24px;

  .title {
    font-size: 30px;
    color: #333333;
    text-align: center;
    font-weight: 600;
  }

  .desc {
    color: #999999;
    letter-spacing: 0;
    text-align: justify;
    text-align: center;
    line-height: 48px;
    font-size: 26px;
    margin-top: 50px;
  }
  .desc-btn {
    letter-spacing: 0;
    text-align: justify;
    line-height: 48px;
    text-align: center;
    margin-top: 96px;
    .pupBtn {
      font-size: 30px;
      color: #fff;
      display: inline-block;
      width: 504px;
      height: 76px;
      line-height: 76px;
      border-radius: 38px;
      background-image: linear-gradient(to right, #23c0ff, #2384ff);
    }
  }

  .y-btn {
    background: #e96e40;
    border-radius: 36px;
    width: 480px;
    text-align: center;
    line-height: 72px;
    color: #fff;
    margin: 76px auto 66px;
  }

  .n-btn {
    text-align: center;
    color: #999999;
  }
}
</style>